import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [needsTerms, setNeedsTerms] = useState(false);
  const [termsInfo, setTermsInfo] = useState({ terms_version: 1, privacy_version: 1 });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.customer);
      setNeedsTerms(data.needs_terms);
      setTermsInfo({ terms_version: data.terms_version, privacy_version: data.privacy_version });
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    let logoutUrl = "";
    try {
      const { data } = await api.post("/auth/logout");
      logoutUrl = data.logout_url;
    } catch {}
    setUser(null);
    return logoutUrl;
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, needsTerms, setNeedsTerms, termsInfo, loading, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
